export default "__VITE_ASSET__hu4LqlRr__"